import * as bossClient from '@boss/boss-client';

import { applyStockResponse, resolveStockWarehouses, summarizeStockStatus } from './stock-status';
import { GetStockStatusInput, StockStatusLine, StockStatusResult } from './types';

export const getStockStatus = async ({
  skus,
  deliveryMethod,
  shopWarehouseCode,
  locale,
  translations,
}: GetStockStatusInput): Promise<StockStatusResult> => {
  const warehouseIds = resolveStockWarehouses({ deliveryMethod, shopWarehouseCode });

  if (!warehouseIds.length) {
    return { lines: [], summary: null };
  }

  const requestedSkuids = skus.map(({ skuid }) => skuid);

  try {
    const response = await bossClient.articleClient.getArticleStockByWarehouseIds({ skus, warehouseIds, locale });
    const lines = applyStockResponse(requestedSkuids, response ?? null, translations);

    return { lines, summary: summarizeStockStatus(lines) };
  } catch {
    // Stock failures never block ordering: every requested skuid gets an empty indicator.
    const lines: StockStatusLine[] = requestedSkuids.map(skuid => ({
      skuid,
      warehouse: null,
      status: null,
      label: null,
    }));

    return { lines, summary: summarizeStockStatus(lines) };
  }
};
